<template>
    <div>
        <div class="row mt-3 mb-4">
            <div class="col-sm-9 col-md-10">
                <h4>
                    KPI Отдела продаж по маржинальной прибыли
                </h4>
            </div>
            <div class="col-sm-3 col-md-2 text-right">
                <b-button
                    @click="updateMotivationData()"
                    size="sm"
                    variant="reload"
                    class="mr-2"
                >
                    Пересчитать <b-icon class="ml-1" icon="arrow-repeat" scale="1.5" aria-label="Reload" :animation="updatingMotivationData ? 'spin' : ''"></b-icon>
                </b-button>
            </div>
        </div>

        <b-overlay
            :show="loading"
            spinner-variant="success"
        >
            <div :aria-hidden="loading ? 'true' : null">

                <div v-for="(month, index) in scoredMotivation.months" :key="index">
                    <div class="mb-2">Выполнение плана за {{monthNames[month.number_of_month - 1]}}: <strong>
                        {{ month.fact_sum | toShortCurrency }} р.
                        <span v-if="month.plan_sum > 1">/ {{ month.plan_sum | toShortCurrency }} р.</span>
                        <span v-else> (План не задан!)</span>
                    </strong></div>
                    <b-progress :max="month.plan_sum" height="2rem" class="mb-3">
                        <b-progress-bar :variant="chooseVariant(month.fact_sum, month.plan_sum)" :value="month.fact_sum" v-if="month.plan_sum > 1">
                            <span><strong>{{(month.fact_sum / month.plan_sum * 100).toFixed(0) }}%</strong></span>
                        </b-progress-bar>
                        <b-progress-bar variant="info" :value="month.fact_sum" v-else>
                            <span><strong>{{ month.fact_sum | toShortCurrency }} р.</strong></span>
                        </b-progress-bar>
                    </b-progress>
                </div>

            </div>
        </b-overlay>
    </div>
</template>

<script>
    import {
        API_GET_PLAN_SALES_SHOW,
        API_POST_PLAN_SALES_CALCULATION
    } from '../../constants'

    export default {
        components: {
        },
        props: {
            isUpdating: { type: Boolean, required: false, default: false },             // If we need to update data
            monthRange: { type: Array,
                          required: true,
                          default: function () {
                              return []
                          }
            },                                                                      // list of months
            selectedMonth: { type: String, required: false, default: null },        // selected month number
        },
        data() {
            return {
                monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
                loading: false,
                additionalGetParameter: '',
                componentRefreshKey: 0,
                visibleUsersDataForTable: [],
                visibleFieldsForTable: [],
                scoredMotivation: [],
                updatingMotivationData: false
            }
        },
        watch: {
            selectedMonth: {
                handler(value) {
                    this.getScoredMotivation()
                },
            },
            isUpdating: {
                handler(value) {
                    if (value == true) {
                        this.getScoredMotivation()
                    }
                },
            },
        },
        mounted() {
        },
        methods: {
            getScoredMotivation() {
                this.loading = true
                this.scoredMotivation = []

                api.call('get', `${API_GET_PLAN_SALES_SHOW}?date_of_quarter=${this.selectedMonth}`).then((response) => {
                    this.scoredMotivation = response.data
                    this.scoredMotivation.months ? this.scoredMotivation.months.forEach((month) => {
                        if (!month.fact_sum) {
                            month.fact_sum = 0
                        }
                    }):''
                    this.loading = false
                    this.$emit('isUpdating', true)
                })
            },
            updateMotivationData() {
                this.updatingMotivationData = true
                this.loading = true

                api.call('post', API_POST_PLAN_SALES_CALCULATION, {date_of_quarter : this.selectedMonth}).then((response) => {
                    this.scoredMotivation = response.data
                    this.scoredMotivation.months ? this.scoredMotivation.months.forEach((month) => {
                        if (!month.fact_sum) {
                            month.fact_sum = 0
                        }
                    }):''
                    this.updatingMotivationData = false
                    this.loading = false
                })
            },
            chooseVariant(fact_sum, plan_sum) {
                let diff = fact_sum / plan_sum * 100

                if (diff < 30) {
                    return 'info'
                } else if (diff >= 30 && diff < 80) {
                    return 'warning'
                } else if (diff >= 80) {
                    return 'success'
                }
            }
        }
    }
</script>
<style>
    .b-table-sticky-column {
        text-align: left!important;
    }
    .motivation-table-th {
        display: block;
        padding: 10px 0;
        color: #000;
    }
    .td-light-gray {
        color: #000;
    }
    .b-table tfoot th,
    .b-table tfoot th.b-table-sticky-column{
        background: #f5f5f5!important;
    }
    .b-table tfoot th b {
        display: block;
        padding: 12px 0;
        text-transform: uppercase;
    }
    .bg-success {
        background-color: #0D6247 !important;
    }
    .progress-bar span {
        font-size: 15px;
    }
</style>
